<template>
  <v-snackbar
    v-model="showHide"
    :timeout="snackTimeout"
    location="top"
    theme="dark"
    :color="snackColor"
    @update:model-value="onStateChange"
  >
    {{ text }}

    <template v-slot:actions>
      <v-btn variant="text" @click="onClose">
        {{ $t("common.actions.close") }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  props: ["show", "text"],
  emits: ["update:show"],
  data() {
    return {
      showHide: false
    }
  },
  watch: {
    show(val) {
      this.showHide = val
    }
  },
  computed: {
    snackColor() {
      return "green-darken-1"
    },
    snackTimeout() {
      return 2800
    }
  },
  methods: {
    onClose() {
      this.showHide = false
    },
    onStateChange(val) {
      this.showHide = val
      this.$emit("update:show", val)
    }
  }
}
</script>

<style></style>
